import { Badge, BlockStack, Button, Card, DataTable, Icon, InlineStack, Text } from '@shopify/polaris';
import { DeleteIcon, EditIcon, PlusIcon, StarIcon } from '@shopify/polaris-icons';
import React, { useCallback, useEffect, useState } from 'react';
import { useDeleteConfirm } from 'context/DeleteConfirmContext';
import TaxInformationModal from './tax_information.modal';
import { TypedUser_tax_information, useDeleteUserTaxInformation, useGetUserTaxInformations } from 'queries/user_tax_information.query';

export default function UserTaxInformationList({ user_id }: { user_id: string }) {
  const { data } = useGetUserTaxInformations({
    user_id,
    limit: 50,
    sort: 'createdAt:desc',
  });
  const [entities, setEntities] = useState<TypedUser_tax_information[]>(null);
  const [showModal, setShowModal] = useState(false);
  const [currentTaxId, setCurrentTaxId] = useState<string>(null);

  useEffect(() => {
    if (!data) return;
    let { body } = data;
    setEntities(body);
  }, [data]);

  const { mutateAsync: deleteTaxInformation } = useDeleteUserTaxInformation();
  const { showDeleteConfirm } = useDeleteConfirm();

  const handleDelete = useCallback(async (id: string) => {
    const confirmed = await showDeleteConfirm('Xóa thông tin thuế', 'Bạn có chắc muốn xóa không? Hành động này không thể khôi phục.');
    if (confirmed) {
      deleteTaxInformation(id);
    }
  }, []);

  const handleOpenCreate = useCallback(() => {
    setCurrentTaxId(null);
    setShowModal(true);
  }, []);

  const handleOpenEdit = useCallback((id: string) => {
    setCurrentTaxId(id);
    setShowModal(true);
  }, []);

  return (
    <BlockStack gap="200">
      <InlineStack align="space-between">
        <Text as="h3" variant="headingMd">
          Thông tin thuế
        </Text>
        <Button icon={PlusIcon} onClick={handleOpenCreate}>
          Thêm thông tin thuế
        </Button>
      </InlineStack>
      <Card padding={'0'}>
        <DataTable
          hideScrollIndicator
          stickyHeader
          verticalAlign="middle"
          columnContentTypes={['text', 'text', 'text', 'text', 'text', 'text', 'text', 'text']}
          headings={['Tên', 'Mã số thuế', 'Mã quan hệ ngân sách', 'CCCD', 'Email nhận hóa đơn', 'Điện thoại', 'Loại hóa đơn', '']}
          rows={
            entities?.map((element) => {
              return [
                <InlineStack wrap={false} align="start" blockAlign="center">
                  {element?.is_default ? (
                    <Button variant="monochromePlain" icon={StarIcon}>
                      {element?.name}
                    </Button>
                  ) : (
                    <Button variant="monochromePlain">{element?.name}</Button>
                  )}
                </InlineStack>,
                <Text as="p">{element?.tax_code || '-'}</Text>,
                <Text as="p">{element?.tax_mamoiquanhengansach || '-'}</Text>,
                <Text as="p">{element?.tax_cccd || '-'}</Text>,
                <Text as="p">{element?.invoice_email || '-'}</Text>,
                <Text as="p">{element?.invoice_phone || '-'}</Text>,
                <Badge tone="attention-strong">{element?.tax_type || 'PERSIONAL'}</Badge>,
                <InlineStack gap="200" wrap={false}>
                  <Button variant="plain" icon={EditIcon} onClick={() => handleOpenEdit(String(element?.id))} />
                  <Button variant="plain" icon={DeleteIcon} onClick={() => handleDelete(String(element?.id))} />
                </InlineStack>,
              ];
            }) || []
          }
        />
      </Card>
      <TaxInformationModal show={showModal} onClose={() => setShowModal(false)} currentTaxInformationId={currentTaxId} user_id={user_id} />
    </BlockStack>
  );
}

